import { render, staticRenderFns } from "./ReportBug.vue?vue&type=template&id=70d93a11&scoped=true&"
import script from "./ReportBug.vue?vue&type=script&lang=js&"
export * from "./ReportBug.vue?vue&type=script&lang=js&"
import style0 from "./ReportBug.vue?vue&type=style&index=0&id=70d93a11&scoped=true&lang=scss&"
import style1 from "./ReportBug.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d93a11",
  null
  
)

export default component.exports